export const purChaseDropDownValues = [
  { purchasesales: 'Sales' },
  { purchasesales: 'Purchase' },
];

export const stockDropdownValues = [{ stock: 'Stock' }, { stock: 'Project' }];


export const SummarySalesDownloadHeaders = [
  { label: "Category", key: "name" },
  { label: "L2", key: "l2" },
  { label: "Spend", key: "spend" },
  { label: "Volume", key: "volume" },
];

export const monthFormat:any = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7:'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
}